import { Button, Dialog, DialogActions, DialogContent, Grid } from '@material-ui/core';
import usePrompt from 'hooks/usePrompt.js';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StorageInvoiceStatus, storageInvoiceTypes } from '../../storageInvoiceConsts';
import { useGetStorageInvoicesListQuery, useUpdateStorageInvoiceMutation } from '../../storageInvoiceSlice.ts';
import DatePicker from "components/DatePicker";
import moment from 'moment';
import NotificationProvider from 'components/NotificationProvider';
import FadeLoader from "react-spinners/FadeLoader";
import { theme } from 'styles/theme';
import FormatService from 'services/formatService';
import { Alert } from '@mui/material';
import { set } from 'lodash';

const StorageInvoiceReGenerate = ({
    invoiceData,
    invoiceCycleType,
}) => {


    const { filters } = useSelector(state => state.storageInvoiceState);
    const [openDialog, setOpenDialog] = useState(false);

    const [startDate, setStartDate] = useState(filters?.['startDate']);
    const [endDate, setEndDate] = useState(filters?.['endDate']);
    const [overlappingInvoice, setOverlappingInvoice] = useState();
    const [exactMatch, setExactMatch] = useState();

    let { data: invoices, error: invoicesError, isLoading: isLoadingInvoices } = useGetStorageInvoicesListQuery({ clientId: filters?.['clientId'] }, { skip: invoiceCycleType != storageInvoiceTypes.TIME_FRAME || !filters?.['clientId'] });

    const weekList = invoices?.map(w => {
        const startDate = FormatService.formatDateNoConversion(w.cycleStart);
        const endDate = FormatService.formatDateNoConversion(w.cycleEnd);
        return {
            startDate,
            endDate
        }
    });

    useEffect(() => {
        setOverlappingInvoice();
        if (invoiceCycleType == storageInvoiceTypes.TIME_FRAME) {
            if (startDate && endDate) {
                const foundInvoice = findOverlappingInvoice();
                if (foundInvoice) {
                    setOverlappingInvoice(foundInvoice);
                }
            }
        }
    }, [startDate, endDate, invoices]);

    const findOverlappingInvoice = () => {
        //Find invoices that overlap with the selected date range
        //If an invoice is found set it to the overlappingInvoice state
        //If the invoice dates are exact set exactMatch to true
        setExactMatch(false);
        const foundInvoice = invoices?.find(invoice => {
            const invoiceStart = moment(invoice.cycleStart).startOf('day');
            const invoiceEnd = moment(invoice.cycleEnd).startOf('day');
            const selectedStart = moment(startDate).startOf('day');
            const selectedEnd = moment(endDate).startOf('day');
            const isExactMatch = invoiceStart.isSame(selectedStart) && invoiceEnd.isSame(selectedEnd);
            if (isExactMatch) {
                setExactMatch(true);
            }
            return (invoiceStart.isSameOrBefore(selectedEnd) && invoiceEnd.isSameOrAfter(selectedStart));

        });
        setOverlappingInvoice(foundInvoice);
    }

    const [updateStorageInvoice, { isLoading }] = useUpdateStorageInvoiceMutation();

    const onSubmitRegenerateData = async () => {
        let option = {
            clientId: parseInt(filters?.['clientId']),
            month: parseInt(filters?.['month']),
            year: parseInt(filters?.['year']),
            startDate: invoiceCycleType == storageInvoiceTypes.TIME_FRAME ? startDate : null,
            endDate: invoiceCycleType == storageInvoiceTypes.TIME_FRAME ? endDate : null,
            invoiceCycleType: invoiceCycleType
        }
        const res = await updateStorageInvoice(option);
        if (res?.error?.data) {
            NotificationProvider.error("Failed to generate the invoice");
        } else {
            NotificationProvider.success("The invoice was generated successfully");
        }

    };

    const onClickGenerate = () => {
        if (invoiceCycleType != storageInvoiceTypes.TIME_FRAME) {
            onSubmitRegenerateData();
            return;
        }
        setOpenDialog(true);
    }

    return (
        <>
            {(invoiceCycleType == storageInvoiceTypes.TIME_FRAME || !invoiceData?.id || invoiceData?.status === StorageInvoiceStatus.PENDING) && <Grid item>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onClickGenerate}
                    disabled={isLoading || !filters?.['clientId']}>
                    Generate Invoice
                </Button>
            </Grid>}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogContent>
                    <Grid container direction='column' spacing={2}>
                        <Grid item xs={12} >
                            <b>Select Cycle Start and End Date</b>
                        </Grid>
                        <Grid item xs={12} >
                            <DatePicker
                                title='Cycle Start'
                                value={startDate}
                                onSelect={setStartDate}
                                required
                                maxDate={moment(Date.now()).format("YYYY-MM-DD")}
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <DatePicker
                                title='Cycle End'
                                value={endDate}
                                onSelect={setEndDate}
                                required
                                minDate={moment(startDate).format("YYYY-MM-DD")}
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <FadeLoader
                                color={theme.palette.primary.main}
                                loading={isLoading}
                                width={4}
                            />
                        </Grid>
                        <Grid item xs={12} >
                            {overlappingInvoice && <Alert severity="warning">
                                There is an existing invoice with the selected date range:
                                <br /><b>{FormatService.formatDateNoConversion(overlappingInvoice.cycleStart)} - {FormatService.formatDateNoConversion(overlappingInvoice.cycleEnd)}</b>
                                <br />  {exactMatch ? " The new invoice will overwrite the previous one" : " The selected dates overlap with the existing invoice, but do not match exactly.the previous invoice will not be overwritten and if both invoices are submitted they may cause duplicate charges, please check carefully."}
                            </Alert>}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!endDate || !startDate || isLoading}
                        onClick={onSubmitRegenerateData}
                    >
                        {isLoading ? "Generating" : "Generate Invoice"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default StorageInvoiceReGenerate;
